import React from 'react'
import Footer from './../../components/Footer';
import Navbar from '../../components/Navbar';
import { PrimaryButton } from '../../components/StyledButtons';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const {t} = useTranslation()

  return (
    <div className='not-found bg-primary'>
      <Navbar />
      <div className='not-found-content container pt-200 pb-100'>
        <p className='font-96 text-primary-orange font-weight-bold'>404</p>
        <p className='font-48 text-white font-weight-semi-bold'>{t('not-found.line-1')}</p>
        <p className='font-20 text-white font-weight-medium pt-20'>{t('not-found.line-2')}</p>
        <div className='pt-30'>
          <PrimaryButton href='/'>{t('button.go-to-homepage')}</PrimaryButton>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default NotFound